// extracted by mini-css-extract-plugin
export default {"IllustrationPiedDePage":"IllustrationPiedDePage_IllustrationPiedDePage__S28Jy"};